import { render, staticRenderFns } from "./action.vue?vue&type=template&id=7cded520&fddApi"
import script from "./action.vue?vue&type=script&lang=js&fddApi"
export * from "./action.vue?vue&type=script&lang=js&fddApi"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports